import React, { useState, JSX } from 'react';
import sanitize from '@/Util/sanitize';
import dayjs from 'dayjs';
import styles from './Quotes.module.scss';
import Image from 'next/image';
import { Carousel, CarouselItem } from 'react-bootstrap';

export type Feedback = {
  '@id': string;
  author?: string;
  date?: string;
  richText: string;
};

const StaticQuotes = ({ feedbacks }: { feedbacks: Feedback[] }): JSX.Element => {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  const onSelect = (eventKey: number) => {
    setActiveIndex(eventKey);
  };

  const slides = feedbacks.map(feedback => (
    <CarouselItem className={styles.quotesItem} key={feedback['@id']}>
      {!!feedback.richText ? (
        <div
          className={styles.quotesText}
          dangerouslySetInnerHTML={{ __html: sanitize(feedback.richText) }}
        />
      ) : (
        <></>
      )}
      {!!feedback.author || !!feedback.date ? (
        <div className={styles.quotesAuthor}>{`${!!feedback.author ? feedback.author : ''}${
          !!feedback.date ? ` (${dayjs(feedback.date).format('MMMM YYYY')})` : ''
        }`}</div>
      ) : (
        <></>
      )}
    </CarouselItem>
  ));

  return (
    <div className={styles.quotesContainer}>
      <Carousel
        className={`quotes_container ${styles.quotes}`}
        activeIndex={activeIndex}
        onSelect={onSelect}
        interval={10000}
        fade
      >
        {slides}
      </Carousel>
      <Image
        className={styles.quotesIconLeft}
        src="/assets/quote_icon_left.svg"
        alt="quotes icon left"
        width={70}
        height={70}
        loader={p => p.src}
      />
      <Image
        className={styles.quotesIconRight}
        src="/assets/quote_icon_right.svg"
        alt="quotes icon right"
        width={70}
        height={70}
        loader={p => p.src}
      />
    </div>
  );
};

export default StaticQuotes;
